import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getString } from '../../helpers/stringHelpers.js';

// Actions
import { actions as routingActions } from '../../ducks/routing.js';
import { actions as authActions } from '../../ducks/auth.js';
import { actions as appActions } from '../../ducks/app.js';
import { actions as customerActions } from '../../ducks/customer.js';

// Components
import ServiceLandingLayout from './ServiceLandingLayout';
import ServiceLandingCard from './ServiceLandingCard/ServiceLandingCard';

const stringsComponent = 'services';

class ServiceLanding extends React.Component {
  componentDidMount() {
    const { setAppBarTitle, onLoadComplete } = this.props;

    setAppBarTitle(getString(stringsComponent, 'TITLE'));
    onLoadComplete();
  }

  render() {
    const { goServiceChild, goDash } = this.props;

    const serviceCards = [];

    governmentServiceSections.forEach((section, i) => {
      serviceCards.push(
        <ServiceLandingCard
          title={section.title}
          summary={section.summary}
          slug={section.slug}
          action={goServiceChild}
        />
      );
    });

    return <ServiceLandingLayout serviceCards={serviceCards} backAction={goDash} />;
  }
}

const mapStateToProps = (state) => ({
  inOutage: state.app.inOutage,
  outageFrom: state.app.outageFrom,
  outageTo: state.app.outageTo,
  outageMessage: state.app.outageMessage,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...routingActions,
      ...appActions,
      ...authActions,
      ...customerActions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ServiceLanding);
